import { RouteConfig } from "vue-router";
import { metaRequireAuth } from "@/router/meta-constants";
import Home from '@/views/home/index.vue';
import Game from '@/views/game/index.vue';
import Checkout from '@/views/checkout/index.vue';
import TicketValidation from '@/views/ticket-validation/index.vue';
import SettingsPage from '@/views/settings/index.vue'
import Reports from '@/views/reports/index.vue';
import History from '@/views/history/index.vue';
import Results from '@/views/results/index.vue';


const authenticatedRoutes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Home',
        meta: metaRequireAuth,
        component: Home,
    },
    {
        path: '/loto',
        name: 'loto',
        meta: {
            ...metaRequireAuth,
            showBetslip:true,
            isGame: 'loto',
            enableLoto:true
        },
        component: Game,
    },
    {
        path: '/loto-vert',
        name: 'loto vert',
        meta: {
            ...metaRequireAuth,
            showBetslip:true,
            isGame: 'loto-vert',
            enableLotovert: true
        },
        component: Game,
    },
    {
        path: '/loto-plus',
        name: 'loto plus',
        meta: {
            ...metaRequireAuth,
            showBetslip: true,
            isGame: 'loto-plus',
            enableLotoPlus: true,
        },
        component: Game,
    },
    {
        path: '/checkout',
        name: 'Checkout',
        meta: {
            ...metaRequireAuth,
            enableCheckout:true
        },
        component: Checkout,

    },
    {
        path: '/ticket-validation',
        name: 'TicketValidation',
        meta: metaRequireAuth,
        component: TicketValidation,
    },
    {
        path: '/settings',
        name: 'Settings Page',
        meta: metaRequireAuth,
        component: SettingsPage,
    },
    {
        path: '/reports',
        name: 'Reports',
        meta: metaRequireAuth,
        component: Reports,
    },
    {
        path: '/history',
        name: 'History',
        meta: metaRequireAuth,
        component: History,
    },
    {
        path: '/results',
        name: 'Results',
        meta: metaRequireAuth,
        component: Results,
    },
];

export default authenticatedRoutes
